import { render, staticRenderFns } from "./points-counter.vue?vue&type=template&id=59e2430b&scoped=true&"
import script from "./points-counter.vue?vue&type=script&lang=js&"
export * from "./points-counter.vue?vue&type=script&lang=js&"
import style0 from "./points-counter.vue?vue&type=style&index=0&id=59e2430b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e2430b",
  null
  
)

export default component.exports